/**
 * rootNavigation — singleton pour accéder au NavigationContainer ref
 * depuis n'importe où dans l'app (composants, callbacks de popups, etc.).
 *
 * Bypasse les problèmes de scope navigation prop dans les modals.
 * Utilisé pour les transitions auth (Login → ConfirmEmail → Login) où
 * navigate/replace via le local navigation prop ne marchent pas
 * fiablement à cause des modal stacks imbriqués.
 *
 * Usage :
 *   import { setRootNavRef, rootNavigate, rootReplace } from '../utils/rootNavigation';
 *
 *   // Dans App.js (1× au mount du NavigationContainer)
 *   setRootNavRef(navigationRef);
 *
 *   // Depuis n'importe quel composant
 *   rootNavigate('ConfirmEmail', { email: 'x@y.com' });
 *   rootReplace('Login', { prefillEmail: 'x@y.com' });
 *
 * v1.12.118 — fix navigation auth flow web.
 */

import { StackActions, CommonActions } from '@react-navigation/native';

let rootRef = null;

export function setRootNavRef(ref) {
  rootRef = ref;
}

export function rootNavigate(name, params) {
  try {
    rootRef?.current?.navigate?.(name, params);
  } catch (e) {
    console.warn('[rootNavigation] navigate failed:', e?.message);
  }
}

export function rootReplace(name, params) {
  try {
    rootRef?.current?.dispatch?.(StackActions.replace(name, params));
  } catch (e) {
    console.warn('[rootNavigation] replace failed, fallback navigate:', e?.message);
    rootNavigate(name, params);
  }
}

// Reset complet du stack vers une route (utile pour fermer plusieurs modals)
export function rootResetTo(name, params) {
  try {
    rootRef?.current?.dispatch?.(
      CommonActions.reset({
        index: 0,
        routes: [{ name, params }],
      })
    );
  } catch (e) {
    console.warn('[rootNavigation] reset failed:', e?.message);
    rootNavigate(name, params);
  }
}

export function getRootNavRef() {
  return rootRef;
}
